import { render } from "./indicator-modal.vue?vue&type=template&id=a06cc5ca"
import script from "./indicator-modal.vue?vue&type=script&lang=js"
export * from "./indicator-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__